import {
  useGetActiveParticipantAccountPaymentAccountGet,
  useGetStipendDetailsRouteStipendsStipendIdGet,
} from "@/api-v3";
import type { PaymentAccount } from "@/features/payments/types/payment-account";

import { normalizeStipend } from "../helpers/normalize-claim";

import { PaymentFetchView } from "./payment-fetch-view";
import { useActionableState } from "./use-actionable-state";

interface StipendFetcherProps {
  id: string;
}

export const StipendFetcher = ({ id }: StipendFetcherProps) => {
  const { data, isLoading, error } =
    useGetStipendDetailsRouteStipendsStipendIdGet(id);
  const { data: activeAccount, isLoading: isAccountLoading } =
    useGetActiveParticipantAccountPaymentAccountGet<PaymentAccount | null>(
      undefined,
      {
        query: { refetchOnWindowFocus: false },
      }
    );
  const actions = useActionableState("stipend", id);

  return (
    <PaymentFetchView
      isLoading={isLoading || isAccountLoading}
      error={error}
      view={
        data ? normalizeStipend(data.data, activeAccount ?? undefined) : null
      }
      actions={actions}
    />
  );
};
